// Normalize filter keys(as same package_name is twice(single search and multiple select package) )
// as per requirements same field twice
export const normalizeFilters = (filters: any) => {
  const normalized = { ...filters };

  if (normalized.single_package_name) {
    // Ensure package_name is always an array
    const existing = Array.isArray(normalized.package_name)
      ? normalized.package_name
      : normalized.package_name
      ? [normalized.package_name]
      : [];

    // Merge without duplicates
    normalized.package_name = Array.from(
      new Set([...existing, normalized.single_package_name])
    );

    delete normalized.single_package_name; // optional, if API doesn’t accept it
  }

  return normalized;
};
